/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldColour } from '@blockly/field-colour';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// Paleta fija de 8 colores: el generador devuelve el índice de la paleta (0-7), no RGB.
Blockly.Blocks.colour_createc_number = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput().appendField(
      new FieldColour('#ff0000')
        .setColours(
          ['#ffffff', '#ff0000', '#ff6600', '#ffff00', '#00ff00', '#00ffff', '#0000ff', '#ff00ff'],
          ['Blanco', 'Rojo', 'Naranja', 'Amarillo', 'Verde', 'Celeste', 'Azul', 'Magenta'],
        )
        .setColumns(4),
      'COLOUR',
    );
    this.setOutput(true, String);
    this.setTooltip(Blockly.Msg.LANG_Color);
    this.setColour(colors.COLOUR_SALIDAS);
  },
};

// Sin mutator a propósito: en prod este bloque nunca muestra la UI de else/elseif y se comporta
// como un if simple.
Blockly.Blocks.controls_if_no_else = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setHelpUrl(Blockly.Msg.CONTROLS_IF_HELPURL);
    this.appendValueInput('IF0')
      .appendField(Blockly.Msg.CONTROLS_IF_MSG_IF)
      .setCheck('Boolean');
    this.appendDummyInput('THEN0')
      .appendField(Blockly.Msg.CONTROLS_IF_MSG_THEN);
    this.appendStatementInput('DO0');
    this.setInputsInline(true);
    this.setColour(colors.COLOUR_CONTROL);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.CONTROLS_IF_TOOLTIP_1);
  },
};

Blockly.Blocks.createc_logic_compare_ldr = {
  init: function () {
    this.setOutputShape(options.SHAPES.HEXAGONAL);
    this.setColour(colors.COLOUR_LOGIC);
    // String 'Boolean', no el constructor: en v13 el constructor Boolean no funciona como check.
    this.setOutput(true, 'Boolean');
    this.appendValueInput('A');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_COMPARE_LUMINOSITY);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_COMPARE_LUMINOSITY_HIGH, 'Dia'],
        [Blockly.Msg.LANG_COMPARE_LUMINOSITY_LOW, 'Noche'],
      ]), 'LUM')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_LOGIC_BOOLEAN_TOOLTIP);
  },
};

// Registrar con `Blockly.Blocks.<tipo> =` literal, no dinámico: scripts/blockly-parity.js
// detecta los bloques con una regex estática.

const restoreElectricity = () => ({
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/Electricidad.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_RESTORE_ELECTRICITY);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_RESTORE_ELECTRICITY_TOOLTIP);
  },
});

Blockly.Blocks.createc_floralis_restore_electricity = restoreElectricity();
Blockly.Blocks.madero_createc_restore_electricity = restoreElectricity();
Blockly.Blocks.obelisco_createc_restore_electricity = restoreElectricity();
Blockly.Blocks.planetario_createc_restore_electricity = restoreElectricity();
Blockly.Blocks.createc_retiro_restore_electricity = restoreElectricity();

const ciudadLdr = () => ({
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/createc/NivelDeLuz.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_CIUDAD_LDR);
    this.setInputsInline(false);
    this.setOutput(true);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_CIUDAD_LDR_TOOLTIP);
  },
});

Blockly.Blocks.floralis_createc_ciudad_ldr = ciudadLdr();
Blockly.Blocks.createc_ciudad_ldr = ciudadLdr();
Blockly.Blocks.ovelisco_createc_ciudad_ldr = ciudadLdr();
Blockly.Blocks.planetario_createc_ciudad_ldr = ciudadLdr();
Blockly.Blocks.train_createc_ciudad_ldr = ciudadLdr();

const createcInitialBlock = () => ({
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput();
    this.appendStatementInput('Start').appendField(Blockly.Msg.LANG_START_2);
    this.appendStatementInput('Repeat').appendField(Blockly.Msg.LANG_REPEAT);
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setTooltip('Inicio');
  },
});

Blockly.Blocks.createc_floralis_initial_block = createcInitialBlock();
Blockly.Blocks.createc_madero_initial_block = createcInitialBlock();
Blockly.Blocks.createc_obelisco_initial_block = createcInitialBlock();
Blockly.Blocks.createc_planetario_initial_block = createcInitialBlock();
Blockly.Blocks.createc_retiro_initial_block = createcInitialBlock();
